import type { ApiService } from './apiService';
import type { PartnerAlias } from '../models/partnerAlias';

/**
 * HTTP client for the PartnerAlias API. Reads are available to any authenticated
 * user; upsert/delete require the Administrator role (enforced server-side).
 */
export interface PartnerAliasService {
  list(): Promise<PartnerAlias[]>;
  upsert(originalName: string, alias: string): Promise<PartnerAlias>;
  remove(originalName: string): Promise<void>;
}

export class HttpPartnerAliasService implements PartnerAliasService {
  constructor(private readonly api: ApiService) {}

  list(): Promise<PartnerAlias[]> {
    return this.api.get<PartnerAlias[]>('/PartnerAlias');
  }

  upsert(originalName: string, alias: string): Promise<PartnerAlias> {
    return this.api.put<PartnerAlias>('/PartnerAlias', { originalName, alias });
  }

  async remove(originalName: string): Promise<void> {
    await this.api.delete<void>(`/PartnerAlias?originalName=${encodeURIComponent(originalName)}`);
  }
}
